import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-card-botao-parametro',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './card-botao-parametro.component.html',
  styleUrl: './card-botao-parametro.component.css'
})
export class CardBotaoParametroComponent {

  @Input() img?: string;
  @Input() texto?: string;
  @Input() selecionado?: boolean;

  @Input() widthImg?: string;

}
